require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./yamhill-county-day-management-center.json") })
        }
      }, "path---yamhill-county-day-management-center");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---yamhill-county-day-management-center!./.cache/json/yamhill-county-day-management-center.json
// module id = 1067
// module chunks = 231608221292675